(function () {
  "use strict";

  if (window.__terraScrollExperience) return;
  window.__terraScrollExperience = true;

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var header = document.querySelector("[data-site-header]");
  var worldHero = document.querySelector("[data-terra-world]");
  var desktopHeaderQuery = window.matchMedia("(min-width: 1024px)");
  var animatedContentSelector = "[data-cinematic-reveal], [data-cinematic-image], .terra-guardian-card, .terra-trace__steps > *";
  var savedTabIndexes = new WeakMap();
  var revealDuration = window.matchMedia("(max-width: 820px)").matches ? 1.04 : 1.12;

  function cubicBezierEase(x1, y1, x2, y2) {
    function coordinate(t, a1, a2) {
      return 3 * (1 - t) * (1 - t) * t * a1 + 3 * (1 - t) * t * t * a2 + t * t * t;
    }

    return function (progress) {
      var low = 0;
      var high = 1;
      var t = progress;

      for (var i = 0; i < 10; i += 1) {
        var x = coordinate(t, x1, x2);
        if (Math.abs(x - progress) < .0001) break;
        if (x < progress) low = t;
        else high = t;
        t = (low + high) / 2;
      }

      return coordinate(t, y1, y2);
    };
  }

  var revealEase = cubicBezierEase(.22, 1, .36, 1);

  function isFunctionalReveal(item) {
    return !!item.closest("header, nav, footer, form, [data-terra-world], .terra-home-hero, .terra-internal-hero, .terra-page-hero, .terra-product-section, .terra-service-product-grid, [class*='checkout'], [class*='cart'], [class*='carousel'], [class*='slider']");
  }

  function isCardReveal(item) {
    return item.matches("article, li, [class*='card']") || !!item.closest(".terra-guardian-grid, .terra-news-grid, .terra-document-grid, .terra-category-grid, .terra-services-grid, .terra-associati-grid, .terra-final-journey__grid");
  }

  function revealVector(item, index) {
    if (isCardReveal(item)) return { x: 0, y: 18 };
    if (isFunctionalReveal(item)) return { x: 0, y: 0 };

    var distanceX = window.matchMedia("(max-width: 820px)").matches ? 22 : 36;
    var distanceY = window.matchMedia("(max-width: 820px)").matches ? 22 : 30;
    var directions = [
      { x: 0, y: distanceY },
      { x: distanceX, y: 0 },
      { x: -distanceX, y: 0 },
      { x: 0, y: distanceY }
    ];

    return directions[index % directions.length];
  }

  function setFocusable(element, active) {
    if (!element) return;

    if (active) {
      if (!savedTabIndexes.has(element)) return;
      var savedTabIndex = savedTabIndexes.get(element);
      if (savedTabIndex === null) element.removeAttribute("tabindex");
      else element.setAttribute("tabindex", savedTabIndex);
      savedTabIndexes.delete(element);
      return;
    }

    if (!savedTabIndexes.has(element)) {
      savedTabIndexes.set(element, element.getAttribute("tabindex"));
    }
    element.setAttribute("tabindex", "-1");
  }

  function setContainerFocusable(container, active) {
    if (!container) return;
    container.querySelectorAll("a[href], button, input, select, textarea, [tabindex]").forEach(function (control) {
      setFocusable(control, active);
    });
  }

  function showAnimatedContent() {
    document.querySelectorAll(animatedContentSelector).forEach(function (item) {
      item.style.removeProperty("opacity");
      item.style.removeProperty("visibility");
      item.style.removeProperty("transform");
    });
  }

  function resetWorldMotion() {
    document.documentElement.classList.remove("terra-world-intro-active");

    document.querySelectorAll("[data-terra-world]").forEach(function (root) {
      root.classList.remove("is-world-motion-ready");
      root.classList.remove("is-world-motion-pending");
      root.classList.remove("is-world-network-chapter");
      root.classList.remove("is-world-intro-armed");
      root.classList.remove("is-world-intro-running");
      root.classList.remove("is-world-intro-complete");
      root.classList.add("is-world-motion-disabled");
      root.removeAttribute("data-progress");

      root.querySelectorAll("[data-world-copy]").forEach(function (item) {
        item.removeAttribute("aria-hidden");
        setContainerFocusable(item, true);
      });

      root.querySelectorAll('[data-world-copy], [data-world-copy] > .terra-kicker, [data-world-copy] > h1, [data-world-copy] > h2, [data-world-copy] > .terra-world-copy__lead, [data-world-copy] > .terra-actions, [data-world-copy] > .terra-actions > *, [data-world-system], [data-world-brand], [data-world-intro-logo], [data-world-node], .terra-world-nodes, .terra-world-network-lite').forEach(function (item) {
        item.style.removeProperty("opacity");
        item.style.removeProperty("visibility");
        item.style.removeProperty("display");
        item.style.removeProperty("transform");
        item.style.removeProperty("pointer-events");
        item.style.removeProperty("--terra-world-scale");
        item.style.removeProperty("--terra-world-x");
        item.style.removeProperty("--terra-world-y");
        item.style.removeProperty("--terra-copy-opacity");
        item.style.removeProperty("--terra-copy-y");
        item.style.removeProperty("--terra-copy-visibility");
        item.style.removeProperty("--terra-copy-pointer-events");
        item.style.removeProperty("--terra-node-layer-opacity");
        item.style.removeProperty("--terra-node-opacity");
        item.style.removeProperty("--terra-node-scale");
        item.style.removeProperty("--terra-node-pointer-events");
      });

      root.querySelectorAll("[data-world-node]").forEach(function (node) {
        node.removeAttribute("aria-hidden");
        setFocusable(node, true);
      });

      var nodeLayer = root.querySelector(".terra-world-nodes");
      if (nodeLayer) nodeLayer.removeAttribute("aria-hidden");
    });
  }

  function setHeader() {
    if (!header) return;

    var normalHeader = window.scrollY > 28;

    if (worldHero && desktopHeaderQuery.matches) {
      var heroBottom = worldHero.getBoundingClientRect().bottom;
      var wasNormal = header.classList.contains("is-scrolled");
      normalHeader = wasNormal ? heroBottom <= 8 : heroBottom <= 0;
    }

    header.classList.toggle("is-scrolled", normalHeader);
  }

  setHeader();
  window.addEventListener("scroll", setHeader, { passive: true });
  window.addEventListener("resize", setHeader, { passive: true });

  if (reduced || !window.gsap || !window.ScrollTrigger) {
    showAnimatedContent();
    resetWorldMotion();
    return;
  }

  try {
    window.gsap.registerPlugin(window.ScrollTrigger);
    window.ScrollTrigger.config({ ignoreMobileResize: true });

    document.querySelectorAll("[data-terra-world]").forEach(function (root) {
      var intro = root.querySelector('[data-world-copy="intro"]');
      var network = root.querySelector('[data-world-copy="network"]');
      var stage = root.querySelector("[data-world-stage]");
      var system = root.querySelector("[data-world-system]");
      var brand = root.querySelector("[data-world-brand]");
      var introLogo = root.querySelector("[data-world-intro-logo]");
      var nodes = root.querySelectorAll("[data-world-node]");
      var nodeLayer = root.querySelector(".terra-world-nodes");
      var networkLayer = root.querySelector(".terra-world-network-lite");
      var introKicker = intro && intro.querySelector(".terra-kicker");
      var introTitle = intro && intro.querySelector("h1");
      var introLead = intro && intro.querySelector(".terra-world-copy__lead");
      var networkKicker = network && network.querySelector(".terra-kicker");
      var networkTitle = network && network.querySelector("h2");
      var networkActions = network && network.querySelector(".terra-actions");
      var networkButtons = network ? network.querySelectorAll(".terra-actions > *") : [];
      var media = window.gsap.matchMedia();
      var isRTL = document.documentElement.dir === "rtl";

      if (!intro || !network || !stage || !system || !brand || !nodeLayer || !networkLayer) return;

      function desktopMaxScale() {
        var stageHeight = stage.getBoundingClientRect().height;
        if (window.innerWidth <= 1280) return stageHeight < 680 ? 1.12 : 1.14;
        if (stageHeight < 720) return 1.1;
        if (stageHeight < 800) return 1.14;
        return 1.18;
      }

      nodes.forEach(function (node) {
        node.style.setProperty("--terra-node-opacity", "0");
        node.style.setProperty("--terra-node-scale", ".96");
      });
      setNodeState(false);
      root.classList.remove("is-world-motion-disabled");
      root.classList.add("is-world-motion-ready");
      root.classList.remove("is-world-motion-pending");
      root.classList.remove("is-mobile-intro-active");
      root.classList.remove("is-mobile-chapter-active");

      function desktopNarrativeScale() {
        return Math.min(desktopMaxScale(), window.innerWidth <= 1280 ? 1.08 : 1.09);
      }

      function desktopRightOffset() {
        var offset = window.innerWidth <= 1280 ? 14 : 22;
        return (isRTL ? -offset : offset) + "vw";
      }

      function desktopLeftOffset() {
        var offset = window.innerWidth <= 1280 ? -14 : -22;
        return (isRTL ? -offset : offset) + "vw";
      }

      function setCopyState(copy, active) {
        if (!copy || copy.getAttribute("aria-hidden") === (active ? "false" : "true")) return;
        copy.setAttribute("aria-hidden", active ? "false" : "true");
        copy.style.setProperty("--terra-copy-visibility", active ? "visible" : "hidden");
        copy.style.setProperty("--terra-copy-pointer-events", active ? "auto" : "none");
        setContainerFocusable(copy, active);
      }

      function setNodeState(active, time, mode) {
        var start = mode === "phone" ? 1.08 : (mode === "tablet" ? .60 : .42);
        var stagger = mode === "phone" ? .08 : (mode === "tablet" ? .06 : .04);
        var hasInteractiveNode = false;
        nodes.forEach(function (node, index) {
          var nodeActive = active && time > start + index * stagger + .08;
          var value = nodeActive ? "false" : "true";
          if (node.getAttribute("aria-hidden") !== value) {
            node.setAttribute("aria-hidden", value);
            node.style.setProperty("--terra-node-pointer-events", nodeActive ? "auto" : "none");
            setFocusable(node, nodeActive);
          }
          hasInteractiveNode = hasInteractiveNode || nodeActive;
        });
        nodeLayer.style.setProperty("--terra-node-pointer-events", "none");
        nodeLayer.setAttribute("aria-hidden", hasInteractiveNode ? "false" : "true");
      }

      function setNarrativeState(time, mode) {
        // Use rendered timeline time, never the ahead-of-scrub scroll progress.
        var phone = mode === "phone";
        var tablet = mode === "tablet";
        var introStart = phone ? 2.92 : (tablet ? 1.18 : 1.435);
        var introEnd = phone ? 4.46 : (tablet ? 2.36 : 1.904);
        var networkStart = phone ? 4.72 : (tablet ? 2.44 : 2.10);
        var networkEnd = phone ? 6.83 : (tablet ? 3.90 : 2.666);
        setCopyState(intro, time >= introStart && time < introEnd);
        setCopyState(network, time >= networkStart && time < networkEnd);
        setNodeState(time > 0, time, mode);
        root.classList.toggle("is-world-network-chapter", !phone && !tablet && time >= 1.904);
      }

      function progress(animation, mode) {
        setNarrativeState(animation.time(), mode);
        root.dataset.progress = "active";
        root.dispatchEvent(new CustomEvent("terra:world-progress", { detail: { progress: animation.progress() } }));
      }

      var mobileGeometry = { y: "0px", scale: 1 };
      function heroStart() {
        return window.innerWidth <= 900
          ? "top " + (parseFloat(getComputedStyle(root).getPropertyValue("--terra-mobile-header-height")) || 0) + "px"
          : "top top";
      }
      function measureMobileGeometry() {
        if (window.innerWidth > 900) return;
        var stageHeight = stage.clientHeight;
        var copyHeight = Math.max(intro.offsetHeight, network.offsetHeight);
        var bottom = Math.max(24, parseFloat(getComputedStyle(stage).paddingBottom) || 0);
        var gap = 24;
        var copyTop = stageHeight - copyHeight - bottom;
        var worldWidth = system.offsetWidth;
        // Include the outer network and badge labels, not just the sphere.
        var diameter = worldWidth * 1.16;
        var rootStyle = getComputedStyle(root);
        var viewportHeight = parseFloat(rootStyle.getPropertyValue("--terra-stable-viewport")) || stageHeight;
        var configuredScale = parseFloat(rootStyle.getPropertyValue("--terra-phone-narrative-scale")) || 1.02;
        var configuredY = rootStyle.getPropertyValue("--terra-phone-narrative-y").trim();
        var preferredY = configuredY ? parseFloat(configuredY) * (configuredY.indexOf("svh") >= 0 ? viewportHeight / 100 : 1) : -viewportHeight * .12;
        var scale = Math.min(configuredScale, (copyTop - gap - 8) / diameter);
        scale = Math.max(.1, scale);
        var center = Math.min(stageHeight / 2 + preferredY, copyTop - gap - diameter * scale / 2);
        center = Math.max(diameter * scale / 2 + 8, center);
        mobileGeometry = { y: (center - stageHeight / 2) + "px", scale: scale };
        root.style.setProperty("--terra-mobile-copy-top", Math.max(0, copyTop) + "px");
      }
      function narrativeWorldY() { return mobileGeometry.y; }
      function narrativeWorldScale() { return mobileGeometry.scale; }
      measureMobileGeometry();
      window.ScrollTrigger.addEventListener("refreshInit", measureMobileGeometry);
      var layoutTimer;
      function requestLayout() {
        clearTimeout(layoutTimer);
        layoutTimer = setTimeout(function () { window.ScrollTrigger.refresh(); }, 200);
      }
      root.addEventListener("terra:world-layout", requestLayout);
      if (document.fonts) document.fonts.ready.then(function () { if (root.isConnected) requestLayout(); });
      root.terraScrollDispose = function () {
        clearTimeout(layoutTimer);
        window.ScrollTrigger.removeEventListener("refreshInit", measureMobileGeometry);
        root.removeEventListener("terra:world-layout", requestLayout);
        media.revert();
      };

      media.add("(min-width: 901px)", function () {
        setNarrativeState(0, false);

        var timeline = window.gsap.timeline({
          defaults: { ease: "sine.inOut" },
          onUpdate: function () { progress(this, false); },
          scrollTrigger: {
            trigger: root,
            start: heroStart,
            end: function () { return "+=" + Math.max(1, root.offsetHeight - stage.offsetHeight); },
            scrub: 1.28,
            invalidateOnRefresh: true
          }
        });

        timeline
          .set(intro, { "--terra-copy-opacity": 0, "--terra-copy-y": "18px" }, 0)
          .set(network, { "--terra-copy-opacity": 0, "--terra-copy-y": "18px" }, 0)
          .set(nodes, { "--terra-node-opacity": 0, "--terra-node-scale": .96 }, 0)
          .set(system, { "--terra-world-x": "0vw" }, 0)
          .set(brand, { scale: 1 }, 0)
          .fromTo(system, { "--terra-world-scale": 1.03 }, { "--terra-world-scale": desktopMaxScale, duration: .552, immediateRender: true }, .276)
          .to(nodes, { "--terra-node-opacity": 1, "--terra-node-scale": 1, stagger: .04, duration: .18 }, .42)
          .to(system, { "--terra-world-scale": desktopMaxScale, duration: .414, ease: "none" }, .828)
          .to(brand, { scale: 1.08, duration: .138, ease: "sine.inOut" }, .828)
          .to(brand, { scale: 1.42, duration: .248, ease: "sine.inOut" }, .966)
          .to(brand, { scale: 1.42, duration: .166, ease: "none" }, 1.214)
          .to(brand, { scale: 1.1, duration: .22, ease: "sine.inOut" }, 1.38)
          .to(system, {
            "--terra-world-x": desktopRightOffset,
            "--terra-world-scale": desktopNarrativeScale,
            duration: .193
          }, 1.242)
          .to(intro, { "--terra-copy-opacity": 1, "--terra-copy-y": "0px", duration: .138 }, 1.435)
          .to(intro, { "--terra-copy-opacity": 0, "--terra-copy-y": "-14px", duration: .138 }, 1.766)
          .to(system, {
            "--terra-world-x": desktopLeftOffset,
            "--terra-world-scale": desktopNarrativeScale,
            duration: .166
          }, 1.904)
          .to(network, { "--terra-copy-opacity": 1, "--terra-copy-y": "0px", duration: .11 }, 2.10)
          .to(system, { "--terra-world-x": "0vw", "--terra-world-scale": 1.08, duration: .276 }, 2.666)
          .to(system, { "--terra-world-x": "0vw", "--terra-world-scale": 1.04, duration: .221, ease: "sine.inOut" }, 2.942)
          .to(network, { "--terra-copy-opacity": 0, "--terra-copy-y": "-14px", duration: .166, ease: "sine.inOut" }, 2.50);

        return function () { timeline.kill(); };
      });

      media.add("(min-width: 721px) and (max-width: 900px)", function () {
        setNarrativeState(0, "tablet");

        var timeline = window.gsap.timeline({
          defaults: { ease: "sine.inOut" },
          onUpdate: function () { progress(this, "tablet"); },
          scrollTrigger: {
            trigger: root,
            start: heroStart,
            end: function () { return "+=" + Math.max(1, root.offsetHeight - stage.offsetHeight); },
            scrub: 1.16,
            invalidateOnRefresh: true
          }
        });

        timeline
          .set(intro, { "--terra-copy-opacity": 1, "--terra-copy-y": "0px" }, 0)
          .set(network, { "--terra-copy-opacity": 1, "--terra-copy-y": "0px" }, 0)
          .set([introKicker, introTitle, introLead, networkKicker, networkTitle, networkActions], { autoAlpha: 0, y: 18 }, 0)
          .set(networkActions, { visibility: "hidden", pointerEvents: "none" }, 0)
          .set(networkButtons, { autoAlpha: 0, y: 12 }, 0)
          .set(nodes, { "--terra-node-opacity": 0, "--terra-node-scale": .96 }, 0)
          .set(system, { "--terra-world-x": "0vw", "--terra-world-y": "0px", "--terra-world-scale": 1.14 }, 0)
          .set(brand, { scale: 1 }, 0)
          .to(nodes, { "--terra-node-opacity": 1, "--terra-node-scale": 1, stagger: .06, duration: .24, ease: "sine.inOut" }, .60)
          .to(system, {
            "--terra-world-y": narrativeWorldY,
            "--terra-world-scale": narrativeWorldScale,
            duration: .5,
            ease: "sine.inOut"
          }, .62)
          .to(introKicker, { autoAlpha: 1, y: 0, duration: .14, ease: "sine.inOut" }, 1.18)
          .to(introTitle, { autoAlpha: 1, y: 0, duration: .16, ease: "sine.inOut" }, 1.3)
          .to(introLead, { autoAlpha: 1, y: 0, duration: .18, ease: "sine.inOut" }, 1.46)
          .to([introKicker, introTitle, introLead], { autoAlpha: 0, y: -12, duration: .18, ease: "sine.inOut" }, 2.18)
          .to(networkKicker, { autoAlpha: 1, y: 0, duration: .15, ease: "sine.inOut" }, 2.44)
          .to(networkTitle, { autoAlpha: 1, y: 0, duration: .18, ease: "sine.inOut" }, 2.59)
          .set(networkActions, { visibility: "visible", pointerEvents: "auto" }, 2.96)
          .to(networkActions, { autoAlpha: 1, y: 0, duration: .16, ease: "sine.inOut" }, 2.96)
          .to(networkButtons, { autoAlpha: 1, y: 0, stagger: .05, duration: .16, ease: "sine.inOut" }, 3)
          .to([networkKicker, networkTitle, networkActions], { autoAlpha: 0, y: -12, duration: .18, ease: "sine.inOut" }, 3.72)
          .to(system, { "--terra-world-y": "-6svh", "--terra-world-scale": 1.08, duration: .28, ease: "sine.inOut" }, 3.90);

        return function () { timeline.kill(); };
      });

      media.add("(max-width: 720px)", function () {
        setNarrativeState(0, "phone");

        function phoneScale(propertyName, fallback) {
          var value = parseFloat(window.getComputedStyle(root).getPropertyValue(propertyName));
          return Number.isFinite(value) ? value : fallback;
        }

        function openingScale() {
          return phoneScale("--terra-phone-opening-scale", 1.17);
        }

        function immersiveScale() {
          return phoneScale("--terra-phone-immersive-scale", 1.27);
        }

        function clearIntroInlineState() {
          system.style.removeProperty("opacity");
          system.style.removeProperty("--terra-world-x");
          system.style.removeProperty("--terra-world-y");
          system.style.removeProperty("--terra-world-scale");
          [brand, networkLayer, nodeLayer].forEach(function (item) {
            item.style.removeProperty("opacity");
            item.style.removeProperty("visibility");
            item.style.removeProperty("transform");
          });
          nodes.forEach(function (node) {
            node.style.removeProperty("--terra-node-opacity");
          });
          if (introLogo) {
            introLogo.style.removeProperty("display");
            introLogo.style.removeProperty("opacity");
            introLogo.style.removeProperty("visibility");
            introLogo.style.removeProperty("transform");
          }
        }

        var timeline = window.gsap.timeline({
          defaults: { ease: "sine.inOut" },
          onUpdate: function () { progress(this, "phone"); },
          scrollTrigger: {
            trigger: root,
            start: heroStart,
            end: function () { return "+=" + Math.max(1, root.offsetHeight - stage.offsetHeight); },
            scrub: .90,
            invalidateOnRefresh: true
          }
        });

        timeline
          .set(intro, { "--terra-copy-opacity": 1, "--terra-copy-y": "0px" }, 0)
          .set(network, { "--terra-copy-opacity": 1, "--terra-copy-y": "0px" }, 0)
          .set([introKicker, introTitle, introLead, networkKicker, networkTitle], { autoAlpha: 0, y: 18 }, 0)
          .set(networkActions, { autoAlpha: 1, y: 0, visibility: "hidden", pointerEvents: "none" }, 0)
          .set(networkButtons, { autoAlpha: 0, y: 12 }, 0)
          .set(nodes, { "--terra-node-opacity": 0, "--terra-node-scale": .96 }, 0)
          .set(system, {
            "--terra-world-x": "0vw",
            "--terra-world-y": "0svh",
            "--terra-world-scale": openingScale
          }, 0)
          .set(brand, { opacity: 1, scale: 1 }, 0)
          .to(system, {
            "--terra-world-y": "-1.2svh",
            "--terra-world-scale": immersiveScale,
            duration: 1.35
          }, .24)
          .to(brand, { scale: 1.26, duration: 1.3 }, .28)
          .to(system, {
            "--terra-world-y": "-1.2svh",
            "--terra-world-scale": immersiveScale,
            duration: .31,
            ease: "none"
          }, 1.59)
          .to(nodes, {
            "--terra-node-opacity": 1,
            "--terra-node-scale": 1,
            stagger: .08,
            duration: .40
          }, 1.08)
          .to(system, {
            "--terra-world-y": narrativeWorldY,
            "--terra-world-scale": narrativeWorldScale,
            duration: .95
          }, 1.9)
          .to(brand, { scale: 1.05, duration: .85 }, 1.9)
          .to(introKicker, { autoAlpha: 1, y: 0, duration: .22 }, 2.92)
          .to(introTitle, { autoAlpha: 1, y: 0, duration: .26 }, 3.10)
          .to(introLead, { autoAlpha: 1, y: 0, duration: .28 }, 3.32)
          .to([introKicker, introTitle, introLead], { autoAlpha: 0, y: -12, duration: .30 }, 4.16)
          .to(networkKicker, { autoAlpha: 1, y: 0, duration: .22 }, 4.72)
          .to(networkTitle, { autoAlpha: 1, y: 0, duration: .26 }, 4.92)
          .set(networkActions, { visibility: "visible", pointerEvents: "auto" }, 5.14)
          .to(networkButtons, { autoAlpha: 1, y: 0, stagger: .12, duration: .25 }, 5.14)
          .to([networkKicker, networkTitle, networkActions], { autoAlpha: 0, y: -12, duration: .28 }, 6.55)
          .to(system, {
            "--terra-world-y": "-6svh",
            "--terra-world-scale": 1.08,
            duration: .65
          }, 6.83);

        var loaderHandler = null;
        var loaderState = window.__terraLoaderState;
        if (introLogo) window.gsap.set(introLogo, { autoAlpha: 0, display: "none", scale: 1 });

        if (!loaderState || !loaderState.complete) {
          loaderHandler = function () {
            loaderHandler = null;
            window.ScrollTrigger.refresh();
          };
          window.addEventListener("terra:loader-complete", loaderHandler, { once: true });
        }

        return function () {
          if (loaderHandler) window.removeEventListener("terra:loader-complete", loaderHandler);
          document.documentElement.classList.remove("terra-world-intro-active");
          timeline.kill();
          clearIntroInlineState();
        };
      });
    });

    document.addEventListener("shopify:section:unload", function (event) {
      event.target.querySelectorAll("[data-terra-world]").forEach(function (root) {
        if (root.terraScrollDispose) root.terraScrollDispose();
      });
    });

    window.gsap.utils.toArray("[data-cinematic-reveal]").forEach(function (item, index) {
      if (isFunctionalReveal(item)) return;
      var vector = revealVector(item, index);
      var siblings = item.parentElement ? Array.prototype.filter.call(item.parentElement.children, function (child) { return child.matches("[data-cinematic-reveal]"); }) : [];
      var siblingIndex = Math.max(0, siblings.indexOf(item));
      window.gsap.fromTo(item, { opacity: 0, x: vector.x, y: vector.y }, { opacity: 1, x: 0, y: 0, duration: revealDuration, delay: Math.min(siblingIndex * .13, .52), ease: revealEase, scrollTrigger: { trigger: item, start: "top 88%", once: true } });
    });

    window.gsap.utils.toArray("[data-cinematic-image]").forEach(function (item) {
      if (isFunctionalReveal(item)) return;
      window.gsap.fromTo(item, { opacity: 0, y: 18, scale: .99 }, { opacity: 1, y: 0, scale: 1, duration: revealDuration, ease: revealEase, scrollTrigger: { trigger: item, start: "top 91%", once: true } });
    });

    window.gsap.utils.toArray(".terra-guardian-card").forEach(function (card, index) {
      window.gsap.from(card, { opacity: 0, y: 18, duration: revealDuration, delay: Math.min(index * .13, .52), ease: revealEase, scrollTrigger: { trigger: card, start: "top 88%", once: true } });
    });

    var trace = document.querySelector(".terra-trace__steps");
    if (trace) {
      window.gsap.from(trace.children, { opacity: 0, y: 18, stagger: { each: .13, amount: Math.min(Math.max(trace.children.length - 1, 0) * .13, .52) }, duration: revealDuration, ease: revealEase, scrollTrigger: { trigger: trace, start: "top 82%", once: true } });
    }
  } catch (error) {
    resetWorldMotion();
    showAnimatedContent();
  }
})();
